<div class="maps-wrapper">
  <div
    id="googleMapWrapper"
    class="googleMapWrapper"
    *ngIf="apiLoaded | async"
    [ngClass]="{
      show: activeMap == mapService.SHOW_GOOGLE_MAPS && googleBasemapVisible,
      hide: activeMap != mapService.SHOW_GOOGLE_MAPS || !googleBasemapVisible
    }"
  >
    <google-map
      #googleMap
      height="100%"
      width="100%"
      [center]="googleMapsCenter"
      [zoom]="mapZoom"
      [options]="googleMapsOptions"
    >
    </google-map>
  </div>

  <div id="olMapWrapper" class="olMapWrapper">
    <div id="ol-map" class="w-100 h-100"></div>
  </div>

  <div id="scaleline" class="ol-scale-line"></div>
</div>
